import React from "react";
import { ClipLoader } from "react-spinners";
import styles from "../Styles/LoadingDisplay.module.scss";

export default class LoadingDisplay extends React.Component {
  render() {
    return (
      <div className={styles.loadingDisplay}>
        <div className={styles.imageContainer}>
          <ClipLoader color="#4a4a4a" loading />
        </div>
      </div>
    );
  }
}
